import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DashboardError } from '@monorepo/nova-ui';
import { DashboardLayout } from '../index';

interface DashboardErrorViewProps {
  error?: string | null;
  onRetry: () => void;
}

export const DashboardErrorView: FC<DashboardErrorViewProps> = ({
  error,
  onRetry,
}) => {
  const { t } = useTranslation('common');

  return (
    <DashboardLayout
      sx={{
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <DashboardError
        title={t('error.title', 'Failed to Load Account')}
        message={
          error ||
          t('error.message', 'Unable to load account data. Please try again.')
        }
        onRetry={onRetry}
        general={true}
      />
    </DashboardLayout>
  );
};
